import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { VideoComponent } from './video.component';
import { VideoPageResolver } from '../../core/resolvers/video-page.resolver';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: ':videoId',
        resolve: { videoPageScope: VideoPageResolver },
        component: VideoComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VideoRoutingModule {}
